var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.regions),function(region){return _c('li',{key:region.id},[_c('Region',{attrs:{"region":region}}),_vm._v(" "),(region.children)?_c('RegionList',{attrs:{"regions":region.children}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }